import { render, staticRenderFns } from "./RecommendKeyword.vue?vue&type=template&id=c4164af8"
import script from "./RecommendKeyword.vue?vue&type=script&lang=js"
export * from "./RecommendKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports